import { A, R } from "@angular/cdk/keycodes";
import { MetaAdInsightsDatePresetEnum, MetaAdEffectiveStatusEnum } from "./enum";

export const Constants = {
  MaxFileSize: '25',
  DefaultPageSize: 25,
  MaxVideoAndDocumentFileSize: 20,
  MaxImageFileSize: 8,
  MaxReviewReplyTextSize: 4093,
  // 25 * 1024 * 1024 = 25MB
  EmailAttachmentSizeLimit: 25 * 1024 * 1024,
  PhoneRegexPattern: /^(\+)?[0-9]+$/,
  //EmailRegexPattern: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  OAuth2EndpointGoogle: 'https://accounts.google.com/o/oauth2/v2/auth',
  EmailRegexPattern: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PasswordRegexPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?+])[A-Za-z\d#$@!%&*?+]{8,30}$/,
  DefaultStartTime: "09:00 AM",
  DefaultEndTime: "05:00 PM",
  MaxSuccessiveRequests: 12, //assumption: value is never zero. if it is, then alter logic wherever refrenced accordingly
  DefaultCountryName: 'United States',
  DefaultCountryCode: 'US',
  KeyboardEnterKey: 'Enter',
  ResendVerificationCodeCountdownInSec: 30,
  CalendlyLink: 'https://calendly.com/xoopah/xoopah-feedback-call',
  ProductionAppUrl: 'https://app.xoopah.com',
  DemoAppUrl: 'https://demoapp.xoopah.com/',
  matchAllDigitsInStringRegex: /\d+/g,
  googleAuthBaseUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
  debounceTime: 250,
  WebsiteRegexPattern: /^(https?|ftp)?(:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.(com|net|org|edu|gov|mil|int|io|ai|co|uk|us|ca|au|in|pk|de|fr|jp|cn|br|mx|es|it|nl|se|no|dk|fi|pl|cz|at|ch|be|ie|nz|za|ae|sa|eg|ng|ke|gh|tz|ug|rw|et|la|app|dev|tech|online|site|website|store|shop|blog|info|biz|xyz|me|tv|cc|ws|name|pro|mobi|asia|tel|jobs|travel|museum|aero|coop|ly|to|fm|am|bit|onion|group)(\.[a-zA-Z]{2,6})?\b(\/[-a-zA-Z0-9@:%_\+.~#?&=\/]*)?$/i,

  // Google Maps
  DefaultMapLoadingStateLatitude: 24.8607,
  DefaultMapLoadingStateLongitude: 67.0011,
  DropPinMarkerRadiusInMiles: 10,
  MilesToMetersConversionFactor: 1609.34,
  MilesToKmConversionFactor: 1.60934,
  SearchMarkerRadiusInMiles: 25,
  StaticCreativesPageSize: 10
};

/**
 * Constants for any limits when interacting with inputs that have to maintained throughout the app.
 * */
export const ContentLimits = {
  BookingInstructionsCharLimit: 2000
}

export const DateTimeFormats = {
  BookingTimeFormat: 'yyyy-MM-dd',
  CurrentDateCalendarFormat: 'MM/dd/yyyy',
  fullDayDateAbbreviatedMonth: 'EEEE, MMM d, y', // Monday, Jun 15, 2015
  fullDayDateFullMonth: 'EEEE, MMMM d y',
};

export const LocalStorageKeys = {
  IsContactDetailsAvailable: 'is_xoopah_contact_details_available',
  ContactFullName: 'xoopah_contact_fullname',
  ContactEmail: 'xoopah_contact_email',
  ContactPhone: 'xoopah_contact_phone',
  Token: "token",
  IsSuperAdmin: "is_super_admin",
  IsOmsUser: 'is_oms_user',
  OmsOrderGuid: 'oms_order_guid',
  PreviousURL: 'previous_url',
  ExternalImpersonationToken: "7vGgUvrnU2qX38v4pyBFyYeJWsrLwQeekG4cEUk0Clo",
  IsOnboardingDetailCompleted: "is_onboarding_detail_completed",
  IsOnboardingCompleted: "is_onboarding_completed",
  IsShowExtendTrialPopup: "is_show_extend_trial_popup",

  //Ad Management
  AdObjectiveId: "ad_objective_id",
  isBusinessPortfolioConnected: "isBusinessPortfolioConnected",
  facebookPageName: "facebookPageName",
  isMetaMessagesSyncing: "isMetaMessagesSyncing",

  adCampaignId: "adCampaignId",
  adId: "adId",
  adObjective: "adObjective",
  adSetId: "adSetId",
  adsAudienceTargetingCompleted: "adsAudienceTargetingCompleted",
  adsBudgetScheduleCompleted: "adsBudgetScheduleCompleted",
  adsCreativeSetupCompleted: "adsCreativeSetupCompleted",
  adsObjectiveCompleted: "adsObjectiveCompleted",
  creativeId: "creativeId",
  metaAdSetId: "metaAdSetId",
  metaCampaingId: "metaCampaingId",
  isShowLeadTab: "isShowLeadTab",
  adsObjective: "adsObjective",
  creativeSetupCompleted: "creativeSetupCompleted",
  adsNewAudienceCompleted: "adsNewAudienceCompleted",
  adsCreateNewBudget: "adsCreateNewBudget",
  previousScreen: "previousScreen",
  iscustomaudiencetosaccepted: "iscustomaudiencetosaccepted",
  customaudiencetoslink: "customaudiencetoslink",
  userFirstName: "userFirstName",
  userEmail: "userEmail",
  isScrapingCompleted: "isScrapingCompleted",
  businessId: "businessId",
  userId: "userId",
  tawkToUserHash: "tawkToHash",
  guestSource: "guestSource",
  isTemporaryAccount: "istemporaryaccount"
}

// sessionStorage, not localStorage: these must survive the reload logout does, but not the tab.
export const SessionStorageKeys = {
  // Onboarding "Log in" for an email that already has an account: the login screen picks it
  // up, prefills the email and skips its email step. Kept out of the URL on purpose.
  OnboardingLoginEmail: 'xoopah_onboarding_login_email',
};

export const ConfirmationPoupupButtonText = {
  Proceed: 'Proceed',
  MayBeLater: 'May be later',
  Yes: 'Yes',
  Delete: 'Delete',
  Archive: 'Archive',
  Next: 'Next',
  Update: 'Update',
  CreateNewServices: 'Create New Services',
  Submit: 'Submit',
  Create: 'Create',
  Restore: 'Restore',
  Connect: 'Connect',
  Disconnect: 'Disconnect',
  ScheduleACall: 'Schedule a Call',
  CancelSubscription: 'Cancel Subscription',
  StartSurvey: 'Start Survey',
  KeepSubscription: 'Keep Subscription',
  Close: 'Close',
  Resubscribe: 'Resubscribe',
  ContinueEditing: 'Continue Editing',
  Exit: 'Exit',
  Discard: 'Discard & close',
  keepEditing: 'Keep Editing',
  DeleteCreative: 'Delete Creative',
  ExtendTrialButtonText: 'Claim My 15 Days',
  
};

export const LoaderKeys = {
  TestKey: 'testkey',
  TestKey2: 'testkey2',
  //REGISTRATION
  UserLoginKey: 'userLogin-userLogin',
  OmsUserLoginKey: 'omsUserLogin-omsUserLogin',
  UserSignupKey: 'userSignup-signUp',
  verifyCodeKey: 'emailVerification-verifyCode',
  ResetPasswordKey: 'resetPassword-reset',
  ResetPasswordEmailKey: 'userLogin-verifyEmail',
  ForgotPasswordEmailKey: 'forgotPassword-verifyEmail',
  SendOTP: 'SendOTP',
  ValidateOTP: 'ValidateOTP',
  CheckIfPasswordExists: 'CheckIfPasswordExists',
  AddPassword: 'AddPassword',
  //CONTACTS
  CreateContactKey: 'createContact-addContact',
  UpdateContactKey: 'editContact-updateContact',
  ContactGridDataKey: 'contactListing-getContactGridData',
  ImportCsvContactsKey: 'importContactModel-importContacts',
  ContactBatchGridDataKey: 'contactbatch-getBatchContactGridData',
  ContactGridInsightsKey: 'contactListing-getContactInsights',
  ArchieveContactKey: 'ArchieveContact',
  RestoreContactKey: 'RestoreContact',
  DeleteContactKey: 'DeleteContact',
  UploadContactsFileKey: 'importContactModel-uploadContactsFile',
  //REVIEWS
  ReviewListingLoaderKey: 'reviewListing-reviewListingCard',
  ReviewRequestGridLoaderKey: 'reviewRequest-reviewRequestGrid',
  ReviewsGridDataKey: 'reviewsListing-getAllReviews',
  ReviewGridInsightsKey: 'reviewsListing-getReviewsInsights',
  ReviewReplyKey: 'reviewCard-sendReviewReply',
  SyncReviewsKey: 'reviewsListing-syncReview',
  BusinessInformationKey: 'reviewRequest-getBusinessInformation',
  //PAYMENTS
  CollectPaymentKey: 'collectpayment-downloadInvoice',
  PaymentGridDataKey: 'paymentListing-getGridColumnsWithData',
  AddInvoiceKey: 'createPayment-addInvoiceKey',
  GetBusinessDetailsKey: 'createPayment-getBusinessDetails',
  ValidatePaymentLinkKey: 'collectPayment-validateCode',
  ChargePaymentButtonKey: 'collectPayment-chargePayment',

  //SUBSCRIPTION
  UpgradePackageButtonKey: 'billingPlan-upgradePackage',
  BillingGridRetryButtonKey: 'billingGrid-retrySubscription',
  ApplyCouponButtonKey: 'billingPlan-applyCoupon',
  AddCreditCardButtonKey: 'billingGrid-addCreditCard',
  PurchaseAddonPackageKey: 'planBilling-purchaseAddonPackage',
  CancelSubscriptionKey: 'planBilling-cancelSubscription',
  UpdateCreditCardButtonKey: 'billingGrid-updateCreditCard',
  SubscriptionPlanLoaderKey: 'billingPlan-subscriptionPlanLoaderKey',
  ResubscribePackageLoaderKey: 'billingGrid-resubscribePackage',
  GetPackageStatusKey: 'billingGrid-getPackageStatusKey',
  MetaDataDetailkey: 'metadatadetailkey',
  MetaAdStatusInfoKey: 'metaAdStatusInfoKey',

  //INTEGRATIONS
  GetBusinessProfileKey: 'googleBusinessIntegration-getBusinessProfile',
  GetBusinessProfileButtonKey: 'googleBusinessIntegration-getBusinessProfileButton',
  IntegrationsKey: 'integrations-getAllBusinessIntegrations',
  IntegrationCategoriesKey: 'integrations-getAllIntegrationCategories',
  GetStripeAccountsKey: 'integrations-getAllBusinessIntegrations',
  GetStripeAccountButtonKey: 'integrations-stripeAccountButton',
  ConnectFacebookKey: 'inbox-connectFacebook',
  ConnectFacebookPageKey: 'connect-facebook-page-key',
  DisconnectIntegrationsKey: 'disconnect-IntegrationsKey',
  GetAccountKey: 'getAccountKey',
  ConnectFB: 'connectfb',
  GetFacebookAccounts: 'get-facebook-accounts',
  GetAdAccounts: 'get-ad-accounts',
  ExchangeFacebookAuthCode: 'exchance-facebook-auth-code',
  //TEMPLATES
  TemplatesKey: 'paymentReminder-getTemplates',
  TemplateButtonKey: 'paymentReminder-templateButtons',
  //HELP & SUPPORT
  ContactSupportButtonKey: 'contactSupport-SubmitContactSupportMessage',
  //BUSINESS SETTINGS
  UserProfileKey: 'businessProfile-getUserProfile',
  GetClosedPeriodsKey: 'businessSchedule-getBusinessHolidaySchedule',
  GetWorkingHoursKey: 'businessSchedule-getBusinessWorkingSchedule',
  UpdateCategoryKey: "confirmationPopup-updateCategoryPopup",
  AddWorkingScedule: "businessSchedule-CloneSchedules",
  UpdateBusinessProfileKey: 'businessProfile-update',
  GetUserProfile: 'get-user-profile',
  BillingInvoiceKey: 'billling-invoice-key',
  SubscriptionGridkey: 'subscription-grid-key',
  BusinessCardKey: 'business-card-key',
  UpdateBusinessSettingsDetailKey: 'businessDetail-update',
  AddBusinessDetailsKey: 'businessDetail-add',
  AddBusinessServiceKey: 'businessService-add',
  UpdateBusinessServiceKey: 'businessService-update',
  UpdateBusinessTimezoneKey: 'businessTimezone-update',
  UpdateBusinessLogoKey: 'businessDetail-updateLogo',
  GenerateInitialChatFlowQuestionsKey: 'generateInitialChatFlows',


  // TEMPLATE SETUP 
  GetAutomatedChatFlowKey: 'automatedchat-get',
  //INBOX
  GetAllConversationMessagesKey: 'inbox-getAllConversationMessages',
  //GENERAL
  CustomerPanelKey: 'customerPanel-getContactById',
  GetAllNotesKey: 'customerPanel-getAllNotes',
  GetAllLablesKey: 'customerPanel-getAllContactLabels',
  GetAllInvoicesKey: 'customerPanel-getAllInvoices',
  GetModuleHistoryKey: 'customerPanel-onActivityOpen',
  AddNotesKey: 'Add-NotesKeys',

  //BOOKING

  CreateBookingKey: 'create-booking-key',
  CompleteBookingKey: 'complete-booking-key',
  CreateBookingSendPaymentKey: 'create-booking-sendpayment-key',
  CreateAdvanceBookingSendPaymentKey: 'create-advance-booking-sendpayment-key',
  UpdateBookingSettings: 'bookingSettings-updateBookingSettings',
  UndoBookingKey: 'undo-booking-key',
  MarkAsNoShowBookingKey: 'MarkAsNoShow-booking-key',
  SendPaymentLinkBookingKey: 'SendPaymentLink-booking-key',
  CancelBookingKey: 'cancel-booking-key',
  showBookingKey: 'show-booking-key',

  //EXTERNAL
  DownloadInvoiceLoaderKey: 'external-downloadInvoice-key',


  //MEDIA UPLOAD

  UploadMediaKey: 'Upload-media-key',

  //META AD OBJECTIVE

  AdOjectiveKey: 'ad-objective-key',
  UpdateAdObjectiveKey: 'update-ad-objective-key',
  CreateAdCreativeSetupKey: 'create-adCreative-setup-key',
  UploadAdCreativeObjectKey: 'upload-adCreative-Key',
  CreateAdBudgetKey: 'create-adBudget-Key',
  UpdateAdBudgetKey: 'updates-adBudget-Key',
  GetLeadFormKey: 'get-leadForm-Key',
  GetAdObjectiveKey: 'get-ad-objective-key',
  GetAdCreativeSetupKey: 'get-ad-creative-key',
  CreateLeadFormKey: 'create-lead-form-key',
  AddFormKey: 'add-form-key',
  GenerateInitialLeadFormQuestions: 'generate-initial-leadform-questions',


  UpdateAdCreativeSetupKey: 'update-adCreative-setup-key',
  SearchAudienceTargetingInterestsKey: 'search-audienceTargetingInterests-key',
  SearchAudienceTargetingLocationKey: 'search-audienceTargetingLocation-key',
  GetAdDetailsKey: 'AdService-GetAdDetails',
  GetLeadFormAnswersKey: 'AdService-GetLeadFormAnswers',
  GetAdAnalyticsKey: 'AdService-GetAdAnalytics',
  PublishAdKey: 'PublishAd-Key',
  RemoveCreativeObject: 'removeCreativeObject-key',
  SaveAudienceTargetingConfigurationKey: 'SaveAudienceTargetingConfigurationKey',
  UpdateMetaAdStatusKey: 'AdService-UpdateMetaAdStatus',
  GetAdBudgetKey: 'GetAdBudgetKey',
  GetAudienceTargetingInterestSuggestionstKey: 'GetAudienceTargetingInterestSuggestionsKey',
  GetFacebookAdAccountStatusKey: 'GetFacebookAdAccountStatusKey',
  GetAudienceTargetingReachEstimateKey: 'GetAudienceTargetingReachEstimateKey',
  GetAdPreviewsKey: 'GetAdPreviewsKey',
  AdManageGrid: 'AdManageGrid',
  ReviewAdCampaignKey: 'ReviewAdCampaignKey',
  GetAllCustomAudienceFilesKey: 'AdsService-GetAllCustomAudienceFiles-key',
  DownloadCustomAudienceFileKey: 'AdsService-DownloadCustomAudienceFile-key',
  AddCustomAudienceFileKey: "AdsService-AddCustomAudienceFile-key",
  DownloadLeadsKey: 'AdsService-DownloadLeadsKey',
  CreateInitialCustomAudiences: 'AdsService-CreateInitialCustomAudiences',
  GetAlladsKey: 'AdsService-GetAllAds',
  CreateNewAdCampaignForUgcKey: 'AdsService-CreateNewAdCampaignForUgc',
  UpdateExistingAdForUgcKey: 'AdsService-UpdateExistingAdForUgc',
  NewAdInExistingStrategyForUgcKey: 'AdsService-NewAdInExistingStrategyForUgc',

  //ONBOARDING
  AddOnboardingBusinessDetailsKey: "OnboardingService-AddOnboardingBusinessDetails-key",
  GetOnboardingBusinessDetailsKey: "OnboardingService-GetOnboardingBusinessDetails-key",
  UpdateOnboardingBusinessDetailsKey: "OnboardingService-UpdateOnboardingBusinessDetails-key",
  UpdateOnboardingCompletionStatusKey: "OnboardingService-UpdateOnboardingCompletionStatus-key",
  ScrapeOnboardingBusinessDetailsKey: "OnboardingService-ScrapeOnboardingBusinessDetails-key",
  
  GetAudienceEngagementSourcesKey: 'GetAudienceEngagementSourcesKey',
  GetAudienceSourcesKey: 'GetAudienceSourcesKey',
  GetTargetingTemplatesKey: 'GetTargetingTemplatesKey',
  getTargetingTemplatesKey: 'getTargetingTemplatesKey',
  AddBusinessCustomAudiencesKey: 'AddBusinessCustomAudiencesKey',
  RedirectFromOnboardingKey: 'RedirectFromOnboarding-Key',
  GetAllAudienceFilesKey: 'AdsService-GetAllAudienceFilesKey-key',
  getAllBusinessPriceTiers: 'LookupsService.getAllBusinessPriceTiers',

  //AD DASHBOARD
  GetAdDataKey: 'adDashboard-getAdKey',
  GetAdDemographicsChartKey: 'adDashboard-getAdDemographicsChartKey',
  GetAdPlatformChartKey: 'adDashboard-getAdPlatformChartKey',
  GetAdPlacementChartKey: 'adDashboard-getAdPlacementChartKey',
  GetAdActivityDataKey: 'adDashboard-getAdActivityDataKey',
  GetAdTilesDataKey: 'adDashboard-getAdTilesDataKey',
  GetAdReachChartKey: 'adDashboard-getAdReachChartKey',
  GetAdReachValueKey: 'adDashboard-getAdReachValueKey',

  GetAudienceTargetingConfigurationKey: 'GetAudienceTargetingConfigurationKey',
  GetSavedAudienceDetailsKey: 'GetSavedAudienceDetailsKey',
  getInstagramLiveAdUrlKey: 'adDashboard-getInstagramLiveAdUrlKey',
  GetCampaignAds:'adDashboard-getCampaignAds',


  //FEATURE UPDATE

  getFeatureUpdateKey: 'getFeatureUpdateKey',
  disableFeatureUpdateKey: 'disableFeatureUpdateKey',

  GetFbAccountKey: 'getfbaccountKey',
  GetTOSDataKey: 'gettOSdataKey',
  GetAdAccountDetailsKey: 'getadaccountdetailsKey',

  GetAdGoalKey: 'getAdGoalKey',
  SetAdGoalKey: 'setAdGoalKey',
  SetAdStrategyKey: 'setAdStrategyKey',
  SetMessagingStrategyKey: 'setMessagingStrategyKey',
  SetAdDestinationKey: 'setAdDestinationKey',
  GetAdDestinationKey: 'getAdDestinationKey',
  GenerateHeadlineAndCaptionKey: 'generateHeadlineAndCaptionKey',
  GetAdStrategy: 'getAdStrategy',
  GetAllAdStrategiesKey: 'getAllAdStrategiesKey',
  GetAllAdDestinationTypesKey: 'getAllAdDestinationTypesKey',
  GetAdStrategyCreativesKey: 'getAdStrategyCreativesKey',
  GenerateOnlyHeadlineKey: 'generateOnlyHeadlineKey',
  GenerateOnlyCaptionKey: 'generateOnlyCaptionKey',
  CreateRetargetingAdKey: 'createRetargetingAdKey',
  GetAdNameKey: 'getAdNameKey',
  UpdateAdNameKey: 'updateAdNameKey',
  GetFacebookPageWhatsappNumbersKey: 'getFacebookPageWhatsappNumbersKey',

  // NEW: Pixel Integration Keys
  GetMetaPixelsKey: 'getMetaPixelsKey',
  GetStandardEventsKey: 'getStandardEventsKey',
  GetCustomConversionsKey: 'getCustomConversionsKey',

  // UGC Creative Keys
  GetAllUgcCreativesKey: 'getAllUgcCreativesKey',
  GetUgcCreativeGoalKey: 'getUgcCreativeGoalKey',
  GetUgcCreativeScriptKey: 'getUgcCreativeScriptKey',
  GetUgcCreativeAssetsKey: 'getUgcCreativeAssetsKey',
  GetUgcCreativeMusicSettingsKey: 'getUgcCreativeMusicSettingsKey',
  DeleteUgcVideoKey: 'deleteUgcVideoKey',
  SetUgcCreativeGoalKey: 'setUgcCreativeGoalKey',
  SetUgcCreativeScriptKey: 'setUgcCreativeScriptKey',
  GenerateUgcCreativeScriptKey: 'generateUgcCreativeScriptKey',
  GenerateAudioKey: 'generateAudioKey',
  CloneVoiceKey: 'cloneVoiceKey',
  SetUgcCreativeGenerationModeKey: 'setUgcCreativeGenerationModeKey',
  GetUgcScriptTonesKey: 'getUgcScriptTonesKey',
  GetUgcMessagingStrategiesKey: 'getUgcMessagingStrategiesKey',
  GetHeyGenAvatarsKey: 'getHeyGenAvatarsKey',
  UploadUgcAssetKey: 'uploadUgcAssetKey',
  SetUgcCreativeAssetsKey: 'setUgcCreativeAssetsKey',
  GetAllBusinessMediaLibraryAssetsKey: 'getAllBusinessMediaLibraryAssetsKey',
  GenerateVideoKey: 'generateVideoKey',
  isFirstCreativetKey: 'isFirstCreativetKey',

  //STATIC CREATIVES
  GetAllStaticCreativesKey: 'GetAllStaticCreativesKey',
  GetStaticCreativeTemplatesKey: 'GetStaticCreativeTemplatesKey',
  GetStaticCreativeTemplateKey: 'GetStaticCreativeTemplateKey',
  AddBusinessStaticCreativeKey: 'AddBusinessStaticCreativeKey',
  UploadStaticCreativeAssetKey: 'UploadStaticCreativeAssetKey',
  GetBusinessStaticCreativeDetailKey: 'GetBusinessStaticCreativeDetailKey',
  UpdateBusinessStaticCreativeDetailKey: 'UpdateBusinessStaticCreativeDetailKey',
  DeleteBusinessStaticCreativeKey: 'DeleteBusinessStaticCreativeKey',
  GetBusinessStaticCreativeEditorPayloadKey: 'GetBusinessStaticCreativeEditorPayloadKey',
  SaveBusinessStaticCreativeDraftKey: 'SaveBusinessStaticCreativeDraftKey',
  ResetStaticCreativeToOriginalKey: 'ResetStaticCreativeToOriginalKey',


  //AI STATIC CREATIVES
  GetAIStaticCreativeDetailsKey: 'GetAIStaticCreativeDetailsKey',
  GetAIStaticCreativeTemplatesKey: 'GetAIStaticCreativeTemplatesKey',
  GetAIStaticCreativeTemplatesCountKey: 'GetAIStaticCreativeTemplatesCountKey',
  GetAllAIStaticCreativesKey: 'GetAllAIStaticCreativesKey',
  IsFirstAIStaticCreativeKey: 'IsFirstAIStaticCreativeKey',
  GetAIStaticCreativeRevisionsKey: 'GetAIStaticCreativeRevisionsKey',
  GetAIStaticCreativeTemplatePromptskey: 'GetAIStaticCreativeTemplatePromptsKey',
  GetAIStaticCreativeUserPromptsKey: 'GetAIStaticCreativeUserPromptsKey',
  AddAIStaticCreativeDetailsKey: 'AddAIStaticCreativeDetailsKey',
  UpdateAIStaticCreativeDetailsKey: 'UpdateAIStaticCreativeDetailsKey',
  SwitchAIStaticCreativeRevisionKey: 'SwitchAIStaticCreativeRevisionKey',
  GenerateAIStaticCreativeRevisionKey: 'GenerateAIStaticCreativeRevisionKey',
  GetAIStaticCreativeTemplateKey: 'GetAIStaticCreativeTemplateKey',
  UploadStaticAssetkey: 'UploadStaticAssetkey',
  DeleteAIStaticCreativeKey: 'DeleteAIStaticCreativeKey',
  DownloadAIStaticCreativeKey: 'DownloadAIStaticCreativeKey',
  UpdateAIStaticCreativeDownloadedOnKey: 'UpdateAIStaticCreativeDownloadedOnKey',

  //AI VIDEO CREATIVES
  GetCreativeFeedKey: 'GetCreativeFeedKey',
  GetCreativeFeedFiltersKey: 'GetCreativeFeedFiltersKey',
  GetHomeSectionsKey: 'GetHomeSectionsKey',
  GetHomeSectionTemplatesKey: 'GetHomeSectionTemplatesKey',
  SetTemplateFavoriteKey: 'SetTemplateFavoriteKey',
  GetFavoriteTemplateKeysKey: 'GetFavoriteTemplateKeysKey',
  GetFavoriteTemplatesKey: 'GetFavoriteTemplatesKey',
  CreateAiVideoDraftKey: 'CreateAiVideoDraftKey',
  GetAiVideoCreativeKey: 'GetAiVideoCreativeKey',
  SetCreativeProductKey: 'SetCreativeProductKey',
  GenerateCreativeScriptKey: 'GenerateCreativeScriptKey',
  GetCreativeAvatarsKey: 'GetCreativeAvatarsKey',
  SetCreativeAvatarKey: 'SetCreativeAvatarKey',
  CreateBusinessAvatarKey: 'CreateBusinessAvatarKey',
  SaveAiVideoDraftKey: 'SaveAiVideoDraftKey',
  AttachCreativeReferenceImageKey: 'AttachCreativeReferenceImageKey',
  RemoveCreativeReferenceImageKey: 'RemoveCreativeReferenceImageKey',
  SubmitAiVideoGenerationKey: 'SubmitAiVideoGenerationKey',
  GetMyCreationsKey: 'GetMyCreationsKey',
  GetMostRecentCreativeKey: 'GetMostRecentCreativeKey',
  GetAllRecentCreativesKey: 'GetAllRecentCreativesKey',
  GetCreationCountsKey: 'GetCreationCountsKey',
  GetBusinessProductsKey: 'GetBusinessProductsKey',
  CheckProductPhotosKey: 'CheckProductPhotosKey',
  CreateBusinessProductKey: 'CreateBusinessProductKey',
  ImportBusinessProductFromUrlKey: 'ImportBusinessProductFromUrlKey',
  PreviewBusinessProductFromUrlKey: 'PreviewBusinessProductFromUrlKey',
  UpdateBusinessProductKey: 'UpdateBusinessProductKey',
  UploadAiVideoAssetKey: 'UploadAiVideoAssetKey',
  ImportAiVideoAssetKey: 'ImportAiVideoAssetKey',
  DeleteBusinessProductKey: 'DeleteBusinessProductKey',
  DescribeBusinessProductMediaKey: 'DescribeBusinessProductMediaKey', // POC

  //IN-APP FEEDBACK
  GetInAppFeedbackPopupDisplayConditionsKey: 'GetInAppFeedbackPopupDisplayConditionsKey',

  GetAllProductUsecases: 'GetAllProductUsecases',
  GetBusinessCategoryUsecases: 'GetBusinessCategoryUsecases',
  GetUsecaseCreativeTemplates: 'GetUsecaseCreativeTemplates'
};

export const CalendarEventClasses = {
  //Fullcalendar Event Class Names
  EventConfirm: 'event-confirm',
  EventWaitingPayment: 'event-waitingpayment',
  EventMarkedAsNoShow: 'event-markedasnoshow',
  EventCancel: 'event-cancel',
  EventComplete: 'event-complete'
}

// // Define an array of colors at the top of the helper.ts file
// export const colors: string[] = [
//   'red',
//   'blue',
//   'green',
//   'orange',
//   'purple',
//   'pink',
//   'brown',
//   'cyan',
//   'magenta',
//   'teal',
//   'indigo',
//   'lime',
// ];

export const colors: string[] = [
  'rgba(37, 109, 242, 1)',
  '#FF5252',
  '#FF5994',
  '#FA8F21',
  '#259B63',
  '#EB35C3',
  '#666070',
  '#000000',
  '#16212D',
  '#4285F4',
  '#0F1325',
  '#542E93',
  '#B4B4B4',
  '#243B43',
  '#F48F8F',
  '#443438',
  '#34A853',
  '#239CA4',
  '#1E89EB',
];

export const Tags = {
  BodyContent: '{{body_content}}',
  ContactFirstName: '{{contact_first_name}}',
  DueDate: '{{due_date}}',
  InvoiceTotal: '{{invoice_total}}',
  InvoiceNumber: '{{invoice_number}}',
  PaymentUrl: '{{payment_url}}',
  ReviewUrl: '{{review_link}}',
  ContactName: '{{contact_name}}',
  MaxSize: '{{max_size}}',
  IntegrationName: '{{integration_name}}',
  SubscriptionEndsOn: '{{subscription_ends_on}}',
  BusinessUserFullname: '{{business_user_fullname}}',
  metaDashboardTag: '{{x}}'
};

export const DropdownTypes = {
  State: { name: 'stateDropDown', className: 'list-stateDropDown' },
  PaymentDiscount: { name: 'paymentDiscountDropDown', className: 'list-paymentDiscountDropDown' },
  ContactFilter: { name: 'ContactFilterDropDown', className: 'list-contactDropDown' },
  ContactInvoice: { name: 'ContactInvoiceDropDown', className: 'list-contactInvoiceDropDown' },
  TimeZoneInvoice: { name: 'TimeZoneDropDownBusinessHours', className: 'list-timeZoneDropDown' },
  TimeDropDownbusiness: { name: 'TimeDropDownbusiness', className: 'list-TimeDropDownBusiness' },
  StructureService: { name: 'StructureServiceDropDown', className: 'list-StructureServiceDropDown' },
  TimeDropDown: { name: 'TimeDropDown', className: 'list-TimeDropDown' },
  BussinessCategoryDropDown: { name: 'BussinessCategoryDropDown', className: 'list-onboardingDetailsCategoryDropdown' },
  BookingTimeDropDown: { name: 'BookingTimeDropDown', className: 'list-stateDropDown' },
  MetaSavedAudienceDropdown: { name: 'MetaSavedAudienceDropdown', className: 'list-MetaSavedAudienceDropdown' },
  budgetTypeDropDown: { name: 'budgetTypeDropDown', className: 'list-budgetTypeDropDown' },
  budgetTimeDropDown: { name: 'budgetTimeDropDown', className: 'list-budgetTimeDropDown' },
  ctaDropDown: { name: 'ctaDropDown', className: 'list-ctaDropDown' },
  AdCampaignGoalsDropdown: { name: 'AdCampaignGoalDropdown', className: 'list-onboardingDetailsDropdown' },
  AdCampaignChallengeDropdown: { name: 'AdCampaignChallengeDropdown', className: 'list-onboardingDetailsDropdown' },
  BussinessCategoryDropDownOnBoarding: { name: 'CategoryDropdown', className: 'list-stateDropDown' },
};


export const XoopahPackages = {
  Trial: { id: 1, name: 'Trial', tag: '', head: '' },
  Basic: { id: 2, name: 'Basic', tag: 'For brands covering their monthly content calendar', head: 'Start creating today' },
  Freemium: { id: 3, name: 'Freemium', tag: '', head: '' },
  DoneForYou: { id: 4, name: 'Done-for-you', tag: '', head: '' },
  Growth: {id : 5, name: 'Growth', tag: 'For teams with a busier monthly calendar', head: 'Scale your content output.'},
  Creator: {id: 6, name: 'Creator', tag: 'For creators making content for every product', head: 'Built for high-volume creators.'}
};

export const PreviousURL = {
  path: '/settings/',
};

export const PercentageValue = {
  TwentyFivePercentage: 25,
  FiftyPercentage: 50,
  EightyPercentage: 80,

};

export const Modules = {
  Settings: 'settings',
  Meeting: 'meeting'
};


export const Components = {
  BillingPlan: 'billing-plan',
  BillingListing: 'billing-listing',
  MeetingListing: 'meeting-listing'
};

export const OnboardingSectionNames = {
  Meta: 'meta',
  Stripe: 'stripe',
  Authorize: 'authorize',
  GoogleMyBusiness: 'googlemybusiness'
}

export const FormErrorMessages = {
  RequiredField: 'This field is required',
  FormNameError: 'Form Name is required',
  HeadlineField: 'Headline is required',
  DecsriptionField: 'Description is required',
  EmailFormatInvalid: 'Email format is invalid',
  PasswordLengthValidation: ' Password must contain 8 or more characters.',
  PasswordFormatValidation: 'Your password can’t start or end with a blank space',
  PasswordMismatch: 'The passwords do not match',
  EmailDoesNotExist: 'Email does not exist in the database.',
  PhoneNumberFormatInvalid: 'Phone number format is invalid',
  PhoneNumberInvalidCharacters: 'Phone number can only contain numbers, spaces, hyphens, and parentheses',
  PhoneNumberTooShort: 'Phone number is too short (minimum 7 digits)',
  PhoneNumberTooLong: 'Phone number is too long (maximum 15 digits)',
  PhoneNumberInvalidFormat: 'Invalid phone number format for selected country',
  PhoneNumberInvalid: 'That doesn\'t look like a valid phone number',
  DurationInvalid: "Duration must be greater than 0",
  PriceInvalid: "Price must be greater than 0",
  StartTimeInvalid: 'Start time is greater than end time',
  EndTimeInvalid: 'End time cannot be before start time',
  TimeOverlap: 'Times overlap with another set of times',
  WebsiteLinkInvalid: 'Website link is invalid',
  DurationRequired: 'Duration is required',
  AmountNonZeroValidation: 'Amount must be greater than 0',
  ShiftConflictValidation: 'Time is overlapping with another shift',
  ServiceAlreadyExists: 'Service already exists.',
  ServiceRequired: 'Service name required.',
  InvalidCardNumber: 'Invalid card number',
  StartTimeEqualsEndTimeValidation: 'Start time cannot be the same as end time',
  BudgetPriceValidation: 'Budget Should be minimum $1',
  GreetingMessage: "Greeting message required",
  EmailChecked: "When you checked email! it will add your email",
  PhoneChecked: "When you checked Phone! it will add your phone",
  FileReadFailed: "Error while reading file",
    InvalidDate: 'Invalid date format. Please pick from calendar'

}

export const Placeholders = {
  Email: 'Joseph@mail.com',
  FirstName: 'Joseph',
  LastName: 'Barbara',
  Password: 'Enter credential',
  ConfirmPassword: 'Confirm new password',
  StreetAddress: '23 Main St, Apt. B',
  PhoneNumber: '+1 225 254-2523',
  State: 'Select state',
  City: 'New York',
  SelectContact: 'Select contact',
  Subject: 'Enter subject line',
  EditorMessage: 'Enter message',
  SearchTags: 'Search tags',
  ReviewReply: 'Reply',
  SearchContact: 'Search contact',
  CardNumber: '4242 4242 4242 4242',
  CardholderName: 'John Doe',
  ExpiryMonth: 'MM',
  ExpiryYear: 'YY',
  CVV: 'CVV',
  ZipCode: '10001',
  SelectCountry: 'Select country',
  CurrentPassword: 'Enter current password',
  NewPassword: 'Enter new password',
  BusinessName: 'Business name',
  WebsiteUrl: 'www.example.com',
  TimeZone: 'Select timezone',
  // SelectCategory: 'Select category',
  SelectService: 'Select service',
  SelectTimezone: 'Select timezone',
  SelectTime: 'Select time',
  Occasion: 'Vacation',
  StartDate: 'Start date',
  EndDate: 'End date',
  BusinessCategory: 'Select business category',
  ScheduleTime: 'HH:MM',
  ServiceName: 'Service name',
  ServiceDescription: 'Enter description',
  ServiceDuration: 'Duration',
  ServicePrice: '0',
  SelectBookingServices: 'Select services',
  SelectDate: 'Select date',
  AmountDefaultValue: '100',
  PercentageDefaultValue: '50',
  DiscountDefaultValue: '0',
  WriteNote: 'Write Note',
  Editlabel: 'Edit label',
  adName: 'Enter ad name',
  adCaption: 'Write your ad copy here (e.g., “Get 20% off your first purchase”',
  CallToAction: 'Select Call To Action',
  AudienceName: 'Enter Audience Name',
  SelectBudget: 'Select Budget',
  PriceBudget: '5',
  HeadLine: 'Add a short, attention-grabbing headline!',
  DateFormat: 'DD/MM/YY',
  SelectAudience: 'Select Audience',
  SearchSources: 'Search Sources',
  SearchGroup: 'Search Interest Groups',
  SelectOne: "Select One",
  SelectColumn: 'Select Column',
  SelectMultiple: "Please Select",
  CustomBusinessCategory: "Business Category",
  AdCreativeWebsite: "www.xoopah.com"
}

export const FormStatus = {
  Vaild: 'VALID',
  Invalid: 'INVALID',
}

export const Toggletypes = {
  OnOff: 'OnOff',
  YesNo: 'yesNo',
}

export const IntegrationUrls = {
  GoogleCalendarUrl: 'https://www.googleapis.com/auth/calendar',
  FacebookBaseUrl: "https://www.facebook.com",
  MetaAdScope: "public_profile%2Cpages_show_list%2Cbusiness_management%2Cinstagram_basic%2Cinstagram_manage_messages%2Cpages_messaging%2Cpages_manage_metadata%2Cpages_read_engagement%2Cads_management%2Cads_read%2Cpages_manage_ads%2Cleads_retrieval",

}

export const AuthTypes = {
  Rerequest: "rerequest",
}

export const ResponseTypes = {
  Code: "code"
}

export const CreditCardValidators = {
  Lengths: { minLength: 13, maxLength: 16 }
}

//Google Tag Manager
export const GoogleTagManagerConstants = {
  CustomTriggerEvents: {
    BusinessUserLoginSuccessful: "event_business_user_log_in_successful",
    BusinessContactCreated: "event_business_contact_created",
    BusinessContactsImported: "event_business_contacts_imported",
    MXPRegisterSuperProperties: "event_register_super_properties",
    UpdateMXPSuperPropertiesOnOnboarding: "event_update_super_properties_on_onboarding",
    MXPRegisterUserProfile: "event_register_user_profile",
    MXPIdentifyUser: "mxp_identify_user",
    OnBoardingMetaAdConnectAccount: "event_onboarding_meta_ad_connect_account",

    //ADS
    OnboardingInstagramPageSelection: "event_onboarding_instagram_page_selection",
    OnboardingFacebookPageSelection: "event_onboarding_facebook_page_selection",
    OnboardingMetaIntegrationConnected: "event_onboarding_meta_integration_connected",
    OnboardingAdAccountSelected: "event_onboarding_ad_account_selected",
    OnboardingBusinessDetailsCompleted: "event_onboarding_business_details_completed",
    MetaIntegrationInitiated: "event_meta_integration_initiated",
    MetaIntegrationCompleted: "event_meta_integration_completed",
    QuickPresetSelection: "event_quick_preset_selection",
    AdObjectiveSelected: "event_ad_objective_selected",
    AdCreativeSetupCompleted: "event_ad_creative_setup_completed",
    AudienceTargetingCompleted: "event_audience_targeting_completed",
    AdTargetingStrategySelection: "event_ad_targeting_strategy_selection",
    LeadFormCreation: "event_lead_form_creation",
    EngagedAudiencesAdded: "event_engaged_audiences_added",
    CustomerListAdded: "event_customer_list_added",
    TemplateFileDownloaded: "event_custom_audience_template_file_downloaded",
    BudgetAndScheduleCompleted: "event_budget_and_schedule_completed",
    PublishClickedAd: "event_published_clicked",
    AdPreviewModalClicked: "event_ad_preview_modal_clicked",
    HeadlineRegenarted:"event_ad_headline_regenerated",
    CaptionRegenarted:"event_ad_caption_regenerated",
    AdStatusPaused:"event_ad_status_paused",
    AdStatusResumed:"event_ad_status_resumed",
  
    //ADs end

    UpdateUserProfileOnOnboarding: "event_register_user_profile_later",
    BusinessUserLogOutSuccessful: "event_business_user_log_out_successful",
    BusinessUserSignUpSuccessful: "event_business_user_sign_up_successful",
    BusinessBookingCreated: "event_business_booking_created",
    ExternalBusinessBookingCreatedWithPayment: "event_external_business_booking_created",
    ExternalBusinessBookingCreatedWithoutPayment: "event_external_business_booking_created_without_payment",
    BusinessBookingCompleted: "event_business_booking_completed",
    ExternalBusinessBookingCompleted: "event_external_business_booking_completed",
    // OnboardingBusinessDetailsCompleted: "event_onboarding_business_details_created",
    OnboardingBusinessServicesCompleted: "event_onboarding_business_services_completed",
    OnboardingBusinessScheduleCompleted: "event_onboarding_business_schedule_completed",
    OnboardingLastStepFinished: "event_onboarding_last_step_finished",
    // StripeIntegrationConnected: "event_stripe_integration_connected",
    // AuthorizeIntegrationConnected: "event_authorize_integration_connected",
    // MetaIntegrationConnected: "event_meta_integration_connected",
    IntegrationConnected: "event_integration_connected",
    // GoogleBusinessIntegrationConnected: "event_google_business_integration_connected",
    BusinessBookingNoShow: "event_business_booking_marked_no_show",
    BusinessBookingRescheduled: "event_business_booking_rescheduled",
    BusinessBookingCancelled: "event_business_booking_cancelled",
    BusinessCalendarViewChanged: "event_business_calendar_view_changed",
    BusinessCalendarCreateButtonClicked: "event_business_calendar_create_button_clicked",
    MessageSentToCustomer: "event_message_sent_to_customer",
    ReviewRequestSent: "event_review_request_sent",
    ReviewReplySent: "event_review_reply_sent",
    NoteAddedOrModified: "event_note_added_or_modified",
    BusinessBookingDetailsViewed: "event_business_booking_details_viewed",
    PaymentLinkSent: "event_payment_link_sent",
    PaymentHistorySearched: "event_payment_history_searched",
    PaymentCharged: "event_payment_charged",
    ExternalLinkBusinessPaymentCharged: "event_external_link_business_payment_charged",
    ConversationThreadViewed: "event_conversation_thread_viewed",
    ConversationArchived: "event_conversation_archived",
    NavigatedToCreatePaymentPage: "event_navigated_to_create_payment_page",
    InvoiceDownloadButtonClicked: "event_invoice_download_button_clicked",
    ExternalInvoiceDownloadButtonClicked: "event_external_invoice_download_button_clicked",
    ExternalBookingFirstStepFinished: "event_external_booking_first_step_finished",
    ExternalBookingSecondStepFinished: "event_external_booking_second_step_finished",
    NextAvailableDateButtonClicked: "event_external_next_available_date_clicked",
    ExternalBookingEmailVerificationSuccessful: "event_external_booking_email_verif_successful",
    ExternalBookingEmailVerificationStarted: "event_external_booking_email_verif_started",
    ExternalBookingResendEmailVerification: "event_external_booking_resend_email_verif",
    AppointmentAddedToCalendarIntegration: "event_appointment_added_to_calendar_integration",
    BusinessUserSubscribed: "event_business_user_subscribed",
    CreateCampaignButtonClicked: "event_create_campaign_button_clicked",
    StrategyTypeSelected: "event_strategy_type_selected",
    GoalSelection: "event_goal_selection",
    AdCreationExited: "event_ad_creation_exited",
    StrategySetupStarted:"event_strategy_setup_started",
    StrategySetupCompleted:"event_strategy_setup_completed",
    WebsiteScraped: "event_website_scraped",
    WebsiteSkippedOrScraped: "event_website_skipped_or_scraped",
    LandingPageView: "event_landing_page_view",
    OnboardingPathSelected: "event_onboarding_path_selected",
    UGCAdCreated: "event_ugc_ad_created",
    ScriptRegenerated: "event_script_regenerated",
    VoiceSelected: "event_voice_selected",
    CreativeDownloaded: "event_creative_downloaded",
    ImageCreativeAdCreated: "event_image_creative_ad_created",
    ImageCreativeAdGoalSelected: "event_image_creative_ad_goal_selected",
    ImageCreativeAssetUploaded: "event_image_creative_asset_uploaded",
    ImageTemplateChanged: "event_image_template_changed",
    LogoUploaded: "event_logo_uploaded",
    ContentRegenerated: "event_content_regenerated",
    ImageCreativePreviewed: "event_image_creative_previewed",
    StaticEditorDownloadButtonClicked: "event_static_editor_download_button_click",
    StaticEditorCreativeDownloaded: "event_static_editor_creative_downloaded",
    StaticEditorCreativePreviewed: "event_static_editor_creative_previewed",
    StaticsPageView: "event_statics_page_view",
    ExitImageCreativeCreationClicked: "event_exit_image_creative_creation_clicked",
    SessionStarted: "event_session_started",
    SessionEnded: "event_session_ended",
    //onboarding - ugc and static

    OnboardingUGCAdTileClicked:"onboarding_ugc_ad_tile_clicked",
    JoinCommunityClicked: "join_community_clicked",
    AIRemixAdCreated: "event_ai_remix_ad_created",
    AIRemixTemplateSelected: "event_ai_remix_template_selected",
    AIRemixAssetUploaded: "event_ai_remix_asset_uploaded",
    AIRemixCustomPromptAdded: "event_ai_remix_custom_prompt_added",
    AIRemixCreativeGenerated: "event_ai_remix_creative_generated",
    AIRemixGenerateButtonClicked: "event_ai_remix_generate_button_clicked",
    AIRemixRevisionGenerated: "event_ai_remix_revision_generated",
    AIRemixRevisionGenerateButtonClicked: "event_ai_remix_revision_generate_button_clicked",
    AIRemixRevisionCloseButtonClicked: "event_ai_remix_revision_close_button_clicked",
    AIRemixCreativeDownloaded: "event_ai_remix_creative_downloaded",
    AIRemixCreativeDownloadClicked: "event_ai_remix_creative_download_clicked",
    ExitAIRemixCreationClicked: "event_exit_ai_remix_creation_clicked",
    AIRemixCreativePreviewed:"event_ai_remix_creative_previewed",

    AIVideoGenerationButtonClicked: "event_ai_video_generation_button_clicked",
    AIVideoCreativeGenerated: "event_ai_video_creative_generated",
    AIVideoCloseButtonClicked: "event_ai_video_close_button_clicked",
    AIVideoCreativeDownloadClicked: "event_ai_video_creative_download_clicked",
    AIVideoCreativeDownloaded: "event_ai_video_creative_downloaded",
    AIVideoCreativePreviewed: "event_ai_video_creative_previewed",
    AiImagesPageView: "event_ai_image_ads_page_view",
    AIRemixCreativeDeleted:"event_ai_remix_creative_deleted",
    UGCCreativePreviewed:"event_ugc_creative_previewed",
    SuggestedRevisionChipClicked: "event_suggested_revision_chip_clicked",
    OnboardingVoiceoverAdTileClicked:"onboarding_voiceover_ad_tile_clicked",
    GuestFlowStarted: "event_guest_flow_started",
    AcquisitionSourceCaptured: "event_acquisition_source_captured",

    //Home
    HomePageView: "event_home_page_view",
    HomeFeatureTileClicked: "event_home_feature_tile_clicked",
    HomeUsecaseTileClicked: "event_home_usecase_tile_clicked",
    HomeInspirationTemplateSelected: "event_home_inspiration_template_selected",

    //Inspiration
    InspirationPageView: "event_inspiration_page_view",
    AIVideoPageView: "event_ai_video_page_view",
    IndustrySelected: "event_industry_selected",
    AdStyleSelected: "event_ad_style_selected",
    InspirationTemplateSelected: "event_template_selected",
    MoreTemplatesBannerClicked: "event_more_templates_banner_clicked",

    //Playbook
    PlaybookPageView: "event_playbook_page_view",
    PlaybookUsecaseSelected: "event_playbook_usecase_selected",

    //Navbar
    NavbarOptionSelected: "event_navbar_option_selected",
    NavbarSignupButtonClicked: "event_navbar_signup_button_clicked",
    PopupSignupButtonClicked: "event_popup_signup_button_clicked",

    //Help
    LiveChatClicked: "event_live_chat_clicked",
    NeedHelpClicked: "event_need_help_clicked",

    //Explainers
    ExplainerPageView: "event_explainer_page_view",
    AvatarVideoTileClicked: "event_avatar_video_tile_clicked",
    VoiceoverVideoTileClicked: "event_voiceover_video_tile_clicked",
    AvatarExplainerGoalStepComplete: "event_avatar_explainer_goal_step_complete",
    AvatarExplainerScriptStepComplete: "event_avatar_explainer_script_step_complete",
    AvatarExplainerTimelineStepComplete: "event_avatar_explainer_timeline_step_complete",
    AvatarExplainerGoalStepExitButtonClicked: "event_avatar_explainer_goal_step_exit_button_clicked",
    AvatarExplainerScriptStepExitButtonClicked: "event_avatar_explainer_script_step_exit_button_clicked",
    AvatarExplainerTimelineStepExitButtonClicked: "event_avatar_explainer_timeline_step_exit_button_clicked",
    VoiceoverExplainerGoalStepComplete: "event_voiceover_explainer_goal_step_complete",
    VoiceoverExplainerScriptStepComplete: "event_voiceover_explainer_script_step_complete",
    VoiceoverExplainerTimelineStepComplete: "event_voiceover_explainer_timeline_step_complete",
    VoiceoverExplainerGoalStepExitButtonClicked: "event_voiceover_explainer_goal_step_exit_button_clicked",
    VoiceoverExplainerScriptStepExitButtonClicked: "event_voiceover_explainer_script_step_exit_button_clicked",
    VoiceoverExplainerTimelineStepExitButtonClicked: "event_voiceover_explainer_timeline_step_exit_button_clicked",
    AvatarExplainerDownloadClicked: "event_avatar_explainer_download_clicked",
    AvatarExplainerDownloaded: "event_avatar_explainer_downloaded",
    VoiceoverExplainerDownloadClicked: "event_voiceover_explainer_download_clicked",
    VoiceoverExplainerDownloaded: "event_voiceover_explainer_downloaded",
    AvatarExplainerPreviewed: "event_avatar_explainer_previewed",
    VoiceoverExplainerPreviewed: "event_voiceover_explainer_previewed",

    // Creative share links
    SharedCreativeLinkCopied: "event_shared_creative_link_copied",
    SharedCreativeLinkViewed: "event_shared_creative_link_viewed",
    SharedCreativePlayed: "event_shared_creative_played",
    SharedCreativeDownload: "event_shared_creative_download",
    SharedCreativeSignInClicked: "event_shared_creative_sign_in_clicked",
    SharedCreativeReported: "event_shared_creative_reported",
    
  },
    DataLayerVars: {
    
    Event: 'event',
    BusinessId: 'business_id',
    // ExternalPaymentBusinessId: 'external_payment_business_id',
    BusinessName: 'business_name',
    BusinessEmail: "business_email",
    AcquisitionSource: "acquisition_source",
    Type: "type",
    IntegrationName: "integration_name",
    AddedContactsCount: "imported_contacts_added_account",
    PaymentType: "payment_type",
    PaymentChannel: "payment_channel",
    PaymentMode: "payment_mode",
    VoiceName:  "voice_name",
    VoiceGender: "voice_gender",
    VoiceSelectionSource: "voice_selection_source",
    ExitStep: "exit_step",
    //Meta Ads
    InstagramSelected: "instagram_selected",
    FacebookSelected: "facebook_selected",
    InterestGroupCount: "interest_group_count",
    InterestGroupNames: "interest_group_names",
    AdObjective: "ad_objective",
    AdName: "ad_name",
    AdStep: "ad_step",
    AdCreativeBodyText: "ad_creative_body_text",
    AdCreativeMediaCount: "ad_creative_media_count",
    AdCreativeHeadline: "ad_creative_headline",
    AdCreativeCTA: "ad_creative_cta",
    AdPlacementFb: "ad_placement_fb",
    AdPlacementInsta: "ad_placement_insta",
    AdLeadFormName: "ad_lead_form_name",
    AdTargetingAudienceName: "ad_targeting_audience_name",
    AdTargetingAudienceType: "ad_targeting_audience_type",
    AdTargetGender: "ad_target_gender",
    AdTargetAgeMax: "ad_target_age_max",
    AdTargetAgeMin: "ad_target_age_min",
    AdAudienceUpperBound: "ad_audience_upper_bound",
    AdAudienceLowerBound: "ad_audience_lower_bound",
    AdDetailedTargetingKeywords: "ad_detailed_targeting_keywords",
    AdSelectedEngagedAudienceSources: "ad_selected_engaged_audience_sources",
    AdCustomAudienceUploadedFileNames: "ad_custom_audience_uploaded_file_names",
    AdSelectedCustomAudienceFileNames: "ad_selected_custom_audience_file_names",
    AdSelectedCustomerListCount: "ad_selected_customer_list_count",
    AdSelectedListsTotalContacts: "ad_selected_lists_total_contacts",
    AdCustomAudienceFileTemplateDownloaded: "ad_custom_audience_file_template_downloaded",
    AdBudgetType: "ad_budget_type",
    AdBudgetAmount: "ad_budget_amount",
    AdStartDate: "ad_start_date",
    AdEndDate: "ad_end_date",
    CampaignDurationDays: "campaign_duration_days",
    AdEstimatedTotalCost: "ad_estimated_total_cost",
    RegenCount: "ad_regen_count",
    TemplateName: "template_name",
    /**
     * The template's own id. AppLovin reads this as item_id — before it existed every
     * event reported the business id there, which made the whole item dimension one
     * row per account.
     *
     * Bare number by choice. It is the per-feature table's primary key, so an AI Video
     * template and an AI Remix template can share it; item_category_id (1 = AI Remix,
     * 2 = AI Video) is what tells the two apart downstream.
     */
    TemplateId: "template_id",
    TemplateCategory: "template_category",
    TemplateType: "template_type",
    OnboardingBusinessCategory: "onboarding_business_category",
    OnboardingBusinessChallenge: "onboarding_business_challenge",
    OnboardingBusinessGoal: "onboarding_business_goal",
    OnboardingBusinessType: "onboarding_business_type",
    OnboardingBusinessPhoneNumber: "onboarding_business_phone_number",
    OnboardingBusinessUsp: "onboarding_business_usp",
    OnboardingLogoUrl: "onboarding_logo_url",
    OnboardingBrandColors: "onboarding_brand_colors",
    OnboardingTypeface: "onboarding_typeface",
    OnboardingBusinessTone: "onboarding_business_tone",
    OnboardingSegment: "onboarding_segment",
    OnboardingSelectedAdAccountName: "onboarding_selected_ad_account_name",
    OnboardingTotalAdAccounts: "onboarding_total_ad_accounts",
    OnboardingSelectedFacebookPageName: "onboarding_selected_facebook_page_name",
    OnboardingSelectedFacebookPageId: "onboarding_selected_facebook_page_id",
    OnboardingTotalFacebookPages: "onboarding_total_facebook_pages",
    OnboardingSelectedInstagramAccountName: "onboarding_selected_instagram_account_name",
    flowOrigin: "flow_origin",
    StrategyType: "strategy_type",
    totalRequiredAds: "total_required_ads",
    GoalSelected: "goal_selected",
    AdCreationExitStep: "ad_creation_exit_step",
    AdCreationExitPageUrl: "ad_creation_exit_page_url",
    AdNameOnExit: "ad_name_on_exit",
    SelectedOnboardingPath: "selected_onboarding_path",
    CreativeFlowSource: "creative_flow_source",
    GoalType: "goal_type",
    // Meta Integration Tracking
    MetaPageId: "meta_page_id",
    MetaInstagramStatus: "meta_instagram_status",
    MetaAdAccountName: "meta_ad_account_name",
    MetaPixelStatus: "meta_pixel_status",
    MetaPixelTOSStatus: "meta_pixel_tos_status",
    UGCType: "ugc_type",
    MessagingStrategy: "messaging_strategy",
    ToneUsed: "tone_used",
    AvatarName: "avatar_name",
    TotalAssets: "total_assets",
    AssetSource: "asset_source",
    MediaType: "media_type",
    PexelSearchText: "pexel_search_text",
    OfferText: "offer_text",
    ScriptText: "script_text",
    EnhancedWithAI: "enhanced_with_ai",
    FilterUsed: "filter_used",
    GenerationModel: "generation_model",
    VoiceType: "voice_type",
    Scenario: "scenario",
    Accent: "accent",
    PreviewPlayed: "preview_played",
    AssetsUploaded: "assets_uploaded",
    MusicUsed: "music_used",
    MusicTrackName: "music_track_name",
    PreviousTemplateName:"previous_template_name",
    NewTemplateName: "new_template_name",
    CustomPrompt: "custom_prompt",
    AIRemixOffer: "ai_remix_offer",
    RevisionPrompt: "revision_prompt",
    RevisionNumber: "revision_number",
    creativeURL: "creative_url",

    // Static editor composition snapshot, reported with the download event
    ThemeColor: "theme_color",
    LogoShown: "logo_shown",
    LocationShown: "location_shown",
    ContactShown: "contact_shown",
    WebsiteShown: "website_shown",
    SuggestionText: "suggestion_text",
    AspectRatio: "aspect_ratio",
    BrandKitUsed: "brand_kit_used",
    GenerationCount: "generation_count",
    UploadedAsset: "uploaded_asset",
    VideoDuration: "video_duration",
    VideoType: "video_type",

    // Meta Ads End

    // Website Scraping
    WebsiteURL: "website_url",
    ScrapingTriggerSource: "scraping_trigger_source",
    CurrentURL: "current_url",
    WebsiteLinkAdded: "website_link_added",

    // Home
    FeatureType: "feature_type",
    UsecaseName: "usecase_name",
    TemplateURL: "template_url",

    // Inspiration
    Industry: "industry",
    AdStyle: "ad_style",
    Source: "source",

    // Navbar
    SelectedTab: "selected_tab",
   // session Tracking
    SessionID: "session_id",
    EntryURL: "entry_url",
    LastActiveModule: "last_active_module",
    exitUrl: "exit_url",
    SessionDuration: "session_duration",

    // Creative share links
    ShareId: "share_id",
    CreativeType: "creative_type",
    CopySource: "copy_source",
    IsLoggedIn: "is_logged_in",
    DownloadType: "download_type",
    CtaType: "cta_type",
    ReportReason: "report_reason"
  },

  DataLayerVals: {
    Stripe: "Stripe",
    Authorize: "Authorize",
    Meta: "Meta",
    Facebook: "Facebook",
    Instagram: "Instagram",
    GoogleBusiness: "Google Business",
    PaymentTypes: {
      Advance: "Advance",
      Full: "Full",
      NoPayment: "No Payment", //GTM Constant Variable
    },
    PaymentChannels: {
      Link: "Link",
      InPerson: "In Person",
    },
    PaymentModes: {
      Card: "Card",
      Cash: "Cash"
    },
    AdTargetingNewAudience: "New Audience",
    AdTargetingSavedAudience: "Saved Audience",
  }
}

export const QueryParamConstants = {
  KeepSubscriptionKey: 'keepsubscription',
  ResubscribeKey: 'resubscribe',
  AddCardKey: 'addcard',
  XoopahRedirectUrlKey: 'xoopahUrlRedirection'
}

export const MetaAdStatuses = {
  Running: "Running",
  Draft: "Draft",
  Scheduled: "Scheduled",
  Completed: "Completed",
  Active: "Active",
  Paused: "Paused",
  InProcess: "In Process",
  InReview: "Under Review",
  CreditCardNeeded: "Credit Card Needed",
  PreApproved: "Pre-Approved",
  Disabled: "Disabled",
  PendingProcess: "Pending Process",
  Error: "Error",
  Rejected: "Rejected",
  FixBilling: "Fix Billing",
  Disapproved: "Disapproved",
  Archived: "Archived",
};

// export const AdsStatusMap = new Map<MetaAdEffectiveStatusEnum,string>(
//   [
//     [MetaAdEffectiveStatusEnum.ACTIVE, 'Active'],
//     [MetaAdEffectiveStatusEnum.PAUSED, 'Paused'],
//     [MetaAdEffectiveStatusEnum.PENDING_REVIEW, 'In-Review'],
//     [MetaAdEffectiveStatusEnum.CREDIT_CARD_NEEDED, 'Credit Card Needed'],
//     [MetaAdEffectiveStatusEnum.PREAPPROVED, 'Pre-Approved'],
//     [MetaAdEffectiveStatusEnum.DISABLED, 'Disabled'],
//     [MetaAdEffectiveStatusEnum.PENDING_PROCESS, 'Pending Process'],
//     [MetaAdEffectiveStatusEnum.WITH_ISSUES, 'Error'],
//     [MetaAdEffectiveStatusEnum.COMPLETED, 'Completed'],
//     [MetaAdEffectiveStatusEnum.DISAPPROVED, 'Disapproved'],
//     [MetaAdEffectiveStatusEnum.PENDING_BILLING_INFO, 'Update Billing Info'],
//     [MetaAdEffectiveStatusEnum.CAMPAIGN_PAUSED, 'Paused'],
//     [MetaAdEffectiveStatusEnum.ARCHIVED, 'Archived'],
//     [MetaAdEffectiveStatusEnum.ADSET_PAUSED, 'Paused'],
//     [MetaAdEffectiveStatusEnum.IN_PROCESS, 'In Process']
//   ]
// )
/*
 durationFilters: any = [
    { id: 1, name: 'Today', comparisonName: 'Yesterday' },
    { id: 2, name: 'This Week', comparisonName: 'Last Week' },
    { id: 3, name: 'This Month', comparisonName: 'Last Month' },
    { id: 4, name: '3 Months', comparisonName: 'Last 3 Month' },
    { id: 5, name: '6 Months', comparisonName: 'Last 6 Month' },
    { id: 6, name: 'All Time', comparisonName: '' },
  ];
*/

export interface IDurationPresetInfo {
  name: string;
  comparisonName: string;
}

export const durationPresets: Map<MetaAdInsightsDatePresetEnum, IDurationPresetInfo> = new Map([
  [MetaAdInsightsDatePresetEnum.Today, { name: 'Today', comparisonName: 'Yesterday' }],
  [MetaAdInsightsDatePresetEnum.Yesterday, { name: 'Yesterday', comparisonName: '' }],
  [MetaAdInsightsDatePresetEnum.ThisWeek, { name: 'This Week', comparisonName: 'Last Week' }],
  [MetaAdInsightsDatePresetEnum.ThisMonth, { name: 'This Month', comparisonName: 'Last Month' }],
  [MetaAdInsightsDatePresetEnum.LastMonth, { name: 'Last Month', comparisonName: '' }],
  [MetaAdInsightsDatePresetEnum.ThreeMonths, { name: '3 Months', comparisonName: 'Last 3 Months' }],
  [MetaAdInsightsDatePresetEnum.LastThreeMonths, { name: 'Last 3 Months', comparisonName: '' }],
  [MetaAdInsightsDatePresetEnum.SixMonths, { name: '6 Months', comparisonName: 'Last 6 Months' }],
  [MetaAdInsightsDatePresetEnum.LastSixMonths, { name: 'Last 6 Months', comparisonName: '' }],
]);

export const ChartYAxisIntervals = {
  list: [
    { max: 50, interval: 10 }, { max: 200, interval: 40 }, { max: 500, interval: 100 }, { max: 1000, interval: 200 }, { max: 5000, interval: 1000 },
    { max: 10000, interval: 2000 }, { max: 20000, interval: 4000 }, { max: 30000, interval: 6000 }, { max: 40000, interval: 8000 }, { max: 50000, interval: 10000 },
    { max: 60000, interval: 12000 }, { max: 70000, interval: 14000 }, { max: 80000, interval: 16000 }, { max: 90000, interval: 18000 }, { max: 100000, interval: 20000 },
    { max: 120000, interval: 24000 }, { max: 140000, interval: 28000 }, { max: 160000, interval: 32000 }, { max: 180000, interval: 36000 }, { max: 200000, interval: 40000 },
    { max: 220000, interval: 44000 }, { max: 240000, interval: 48000 }, { max: 260000, interval: 52000 }, { max: 280000, interval: 56000 }, { max: 300000, interval: 60000 },
    { max: 320000, interval: 64000 }, { max: 340000, interval: 68000 }, { max: 360000, interval: 72000 }, { max: 380000, interval: 76000 }, { max: 400000, interval: 80000 },
    { max: 420000, interval: 84000 }, { max: 440000, interval: 88000 }, { max: 460000, interval: 92000 }, { max: 480000, interval: 96000 }, { max: 500000, interval: 100000 },
    { max: 520000, interval: 104000 }, { max: 540000, interval: 108000 }, { max: 560000, interval: 112000 }, { max: 580000, interval: 116000 }, { max: 600000, interval: 120000 },
    { max: 620000, interval: 124000 }, { max: 640000, interval: 128000 }, { max: 660000, interval: 132000 }, { max: 680000, interval: 136000 }, { max: 700000, interval: 140000 },
    { max: 720000, interval: 144000 }, { max: 740000, interval: 148000 }, { max: 760000, interval: 152000 }, { max: 780000, interval: 156000 }, { max: 800000, interval: 160000 },
    { max: 820000, interval: 164000 }, { max: 840000, interval: 168000 }, { max: 860000, interval: 172000 }, { max: 880000, interval: 176000 }, { max: 900000, interval: 180000 },
    { max: 920000, interval: 184000 }, { max: 940000, interval: 186000 }, { max: 960000, interval: 190000 }, { max: 980000, interval: 194000 }, { max: 1000000, interval: 200000 }
  ]
}

export const commonFileTypes = { image: 'image', photo: 'photo', video: 'video' }
export const messagingDestinationIds: Array<number> = [1, 2, 3, 7, 8]


//#endregion

//hello





